<style media="screen" type="text/css">

.shipment-tracker-block {
  background: #FFFFFF;
  box-shadow: 0px 5px 20px rgba(143, 143, 143, 0.25);
  border-radius: 30px !important;
}

/* active line */
.shipment-time-line .active .v-timeline::before {
  background: #1DC895 !important;
  /*height: 80% !important;*/
}

/* hide line for first status*/
.shipment-time-line .initial .v-timeline::before {
  height: 0% !important;
}

.shipment-time-line .disabled ::before {
  background: #CCCCCC !important;
}


/* inner dots  */
.shipment-time-line .v-timeline-item__inner-dot {
  background: transparent !important;
  height: 13px !important;
  width: 13px !important;
}

.shipment-time-line .current-status .v-timeline-item__inner-dot {
  border: solid 2px #FFFF !important;
  margin: 0px !important;
  background: #1DC895 !important;
}

/*small dot*/
.shipment-time-line .v-timeline-item__dot {
  box-shadow: none !important;
}

.shipment-time-line .current-status .v-timeline-item__dot {
  border: solid 2px #1DC895;
  height: 17px !important;
  width: 17px !important;
}

.shipment-time-line .completed .v-timeline-item__dot {
  border: solid 2px #1DC895;
  height: 13px !important;
  width: 13px !important;
}

.shipment-time-line .v-timeline-item__dot {
  border: solid 2px #CCCCCC;
  height: 13px !important;
  width: 13px !important;
}

.shipment-time-line .initial .v-timeline-item__dot,
.shipment-time-line .end .v-timeline-item__dot,
.shipment-time-line .disabled .v-timeline-item__dot {
  height: 17px !important;
  width: 17px !important;
}

.negative-margin-40 {
  margin-left: -40px
}

/* fonnt  snad style*/
.status-title-text {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 134%;
  color: #646464;
}

.track-location-text,
.track-date-text {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 11px;
  line-height: 160%;
  display: flex;
  align-items: center;
  color: #A0A0A0;
}

/* hold  status  overlay */
.hold-overlay {
  background-color: rgba(33, 33, 33, 0.06);
}

.overlay-on-hold {
  padding: 5px 10px;
  color: #ffff;
  background-color: #F2994A;
  border-radius: 5px;
}

.overlay-cancelled {
  padding: 5px 10px;
  color: #ffff;
  background-color: #EB5757;
  border-radius: 5px;
}


</style>


<template>
  <div>
    <v-card class="shipment-tracker-block" max-width="290">
      <v-card-text class="shipment-time-line active">
        <p class="page-title pb-5 pt-1  px-1 text-left">
          {{ $lang.SHIPMENT_TRACKING }}
        </p>
        <div v-for="(item,i) in shipment_status_log" :key="i" :class="CheckForCompleted(item,i)">
          <v-timeline :class="isCurrentStatus(item.status,i)" align-top class="py-0 negative-margin-40 " dense>
            <v-timeline-item class="py-0 " color="primary" small>
              <v-row class="py-1">
                <v-col class="py-0" cols="12" style="min-height:70px">
                  <p class="status-title-text">{{ item.action }}</p>
                  <p v-if="item.created" class="track-location-text">
                    {{ item.created }}
                  </p>
                  <p v-if="item.location" class="track-location-text">{{ item.location }}</p>
                </v-col>
              </v-row>
            </v-timeline-item>
          </v-timeline>
        </div>
      </v-card-text>

      <!-- show overlay if Order On hold -->
      <!-- 	<v-overlay
        absolute
        opacity="1"
        class="hold-overlay"
        disabled
        color="rgba(255, 255, 255, 0.7)"
        v-if="[$keys.ON_HOLD,$keys.CANCELLED].includes(shipment_details.shipment_status)"
        >
        <span :class="'overlay-'+getClassSatus(shipment_details.shipment_status)" v-if="shipment_details.shipment_status">
          <b>{{shipment_details.shipment_status}}</b>
        </span>
      </v-overlay> -->


    </v-card>
    <div v-if="shipment_details.shipment_status==$keys.OUT_FOR_DELIVERY" class="text-center negative-margin-40 mt-5">
      <a :href="'https://'+host+'/map/?r_lat='+shipment_details.retailer_latitude+'&r_lng='+shipment_details.retailer_longitude+'&d_agent_id='+shipment_details.delivery_agent_id"
         target="_blank">
        <v-btn color="primary" style="margin-left: -100px" width="100px">
          <b>{{ $lang.TRACK }}</b>
        </v-btn>
      </a>
    </div>

  </div>
</template>

<script type="text/javascript">
export default {
  props: ["shipment_status_log", "shipment_details"],
  data() {
    return {
      overlay: true,
      host: location.host,
    }
  },
  methods: {
    CheckForCompleted(item, i) {
      console.log(item)
      let cl = ""
      if (i == (this.shipment_status_log.length - 1))
        cl = cl + 'initial '
      if (i == 0)
        cl = cl + 'end '
      // let status_list=this.shipment_status_log
      // let is_exist = status_list.some( obj => obj.action === item.status )
      // console.log("is_exist="+is_exist)
      if (item.status == this.$keys.ACTIVE || item.status == this.$keys.CURRENT) {
        cl = cl + ' active'
      }
      console.log(cl)
      return cl
    },
    isCurrentStatus(status, i) {
      if (status == this.$keys.ACTIVE)
        return 'completed'
      if (status == this.$keys.CURRENT)
        return 'current-status'
    },

  }
}
</script>